import { getActionMetadataConfigFromAction } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import { RedesignedActionCategoryMap } from 'automation-ui-action-features/constants/ActionCategories';
import ActionCategoryThemes from 'automation-ui-action-features/constants/ActionCategoryThemes';
export function getActionIconAndColor({
  action,
  extensionDefinitions
}) {
  const actionMetadataConfig = getActionMetadataConfigFromAction(action, '', extensionDefinitions);
  const extensionDefinition = extensionDefinitions && extensionDefinitions[action.actionTypeId];
  return getActionIconAndColorForType({
    actionMetadataConfig,
    extensionDefinition
  });
}
export function getActionIconAndColorForType({
  actionMetadataConfig,
  extensionDefinition
}) {
  const isHubSpotDefinedExtension = !!extensionDefinition && 'listingCategory' in extensionDefinition;
  const category = isHubSpotDefinedExtension ? RedesignedActionCategoryMap[extensionDefinition.listingCategory] : actionMetadataConfig.category;
  const categoryTheme = category && ActionCategoryThemes[category] || ActionCategoryThemes.UNCATEGORIZED;
  let iconName = actionMetadataConfig.icon;
  let iconUrl = undefined;
  let theme = actionMetadataConfig.theme;
  if (actionMetadataConfig.category !== 'QUICK_ACTIONS') {
    iconName = categoryTheme.icon;
    theme = categoryTheme.theme;
  }
  if (!isHubSpotDefinedExtension && extensionDefinition) {
    iconUrl = extensionDefinition.iconUrl || undefined;
    theme = ActionCategoryThemes.UNCATEGORIZED.theme;
  }
  return {
    iconName,
    iconUrl,
    theme
  };
}